/**
 * @exports hybridFn
 * @desc hybrid 功能封装
 * @date 2018/02/07
 * @author lei.you
 * */
const toolkit = window.toolkit;
export default{
  //
    /**
     * @desc 回退
     * @param {object} 参数
     * @param {function} 回调
     * */
  goBack(params,callback){
    toolkit.call("invoke",{methodName:'goBack',params:params},callback);
  },
  //
    /**
     * @desc 获取token
     * @param {object} 参数
     * @param {function} 回调
     * */
  getToken(params,callback){
    toolkit.call("invoke",{methodName:'getSsoToken',params:params},callback);
  },
    /**
     * @desc  获取app 版本
     * @param {object} 参数
     * @param {function} 回调
     * */
  getToolkitVersion(params,callback){
    toolkit.call("invoke",{methodName:'getToolkitVersion',params:params},callback);
  },
  // 获取系统平台
    /**
     * @desc 回退
     * @param {object} 参数
     * @param {function} 回调
     * */
   getSystemPlatform(params,callback){
    toolkit.call("invoke",{methodName:'getSystemPlatform',params:params},callback);
  },
    /**
     * @desc 跳转登录
     * @param {object} 参数
     * @param {function} 回调
     * */
  gotoLogin(params,callback){
    toolkit.call("invoke",{methodName:'goLogin',params:params},callback);
  },
    /**
     * @desc 关闭本页面
     * @param {object} 参数
     * @param {function} 回调
     * */
  close(params,callback){
    toolkit.call("invoke",{methodName:'close',params:params},callback);
  },
    /**
     * @desc 错误发送
     * @param {object} 参数
     * @param {function} 回调
     * */
  onError(params,callback){
    toolkit.call("invoke",{methodName:'onError',params:params},callback);
  },
    /**
     * @desc 头部控制
     * @param {object} 参数
     * @param {function} 回调
     * */
  controlTitle(params,callback){
    toolkit.call("invoke",{methodName:'controlTitle',params:params},callback);
  },
  //
    /**
     * @desc 新开webview
     * @param {object} 参数
     * @param {function} 回调
     * */
  openNewPage(params,callback){
    toolkit.call("invoke",{methodName:'openNewPage',params:params},callback);
  },
  //
    /**
     * @desc 拨打电话
     * @param {object} 参数
     * @param {function} 回调
     * */
  dial(params,callback){
    toolkit.call("invoke",{methodName:'dial',params:params},callback);
  },
  /**
   * @desc 是否使用物理回退
   * @param {object} 参数
   * @param {function} 回调
   * */
  controlBackPress(params,callback){
      toolkit.call("invoke",{methodName:'controlBackPress',params:params},callback);
  }
}
